export default __webpack_public_path__ + "static/16-7b409af913d745df14adf9d3c9dc4226.png";